import React from 'react';
import './emptyListMessage.css';

const EmptyListMessage = () => {
    return (
        <div className={"empty-list-message"}>
            <i className="empty-list-message__icon bi bi-x-octagon"></i>
            <p className={"empty-list-message__text"}>К сожалению, документы не найдены</p>
        </div>
    );
};

export default EmptyListMessage;